import React from "react";
import { useHistory, useLocation } from "react-router";
import PropTypes from "prop-types";
import CdpEnterYourCarDetails from "../cdp-enter-your-car-details";
import styles from "./styles.css";
import CdpValuationCard from "../cdp-valuation-card";
import CdpNextSteps from "../cdp-next-steps/component";
import { CDP_REDIRECTION_KEY } from "../../../au-c2b/constants/app-constants";
import { setItem } from "../../../utils/helpers/storage-crud";
import { TRADE_IN_GA_EVENTS } from "./tracking";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import CdpTradeInValuation from "../cdp-trade-in-valuation/component";

const CdpCarToTradeIn = ({tradeInData, setRedirectionDataConnect, gaId}) => {
    const [isEditFlow, setIsEditFlow] = React.useState(false);
    const location = useLocation();
    const {pathname} = location;
    const history = useHistory();
    const showEdit = !tradeInData?.offeredPrice && tradeInData?.firstTradeMode === "BANNER";

    const onEditValuationScreen = () => {
        if (tradeInData.offeredPrice || tradeInData.firstTradeMode !== "BANNER") {
            window.scrollTo(0, 0);
            if (tradeInData.offeredPrice) {
                const redirectionDataObj = {
                    from: "cdp",
                    redirectLink: pathname
                };
                setRedirectionDataConnect(redirectionDataObj);
                setItem(redirectionDataObj, CDP_REDIRECTION_KEY);
            }
            trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.exactEditClicked, {
                ...TRADE_IN_GA_EVENTS.exactEditClicked
            });
            history.push("/sell-your-car/");
        } else {
            setIsEditFlow(true);
            trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.editClicked, {
                ...TRADE_IN_GA_EVENTS.editClicked
            });
        }
    };

    const renderCard = () => {
        if (!isEditFlow && !tradeInData.expired && tradeInData.havingAnOffer && tradeInData.offeredPrice) {
            return (
                <CdpTradeInValuation showEdit={showEdit} onEditClick={onEditValuationScreen} tradeInData={tradeInData} gaId={gaId}/>
            );
        } else if (!isEditFlow && !tradeInData.expired && tradeInData.firstTradeMode === "BANNER" && tradeInData.dsOfferedPrice && !tradeInData.makeModelFlow) {
            return (
                <div styleName={"styles.valuationWrapper"}>
                    <CdpValuationCard showEdit={showEdit} onEditClick={onEditValuationScreen} />
                    <CdpNextSteps />
                </div>
            );
        } else {
            return <CdpEnterYourCarDetails setIsEditFlow={setIsEditFlow} />;
        }
    };

    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.leftSide"}>
                <p styleName={"styles.heading"}>{ !tradeInData.expired && tradeInData.havingAnOffer && tradeInData.offeredPrice ? "Trade-in valuation" : "Do you have a car to trade in?" }</p>
                { !(!tradeInData.expired && tradeInData.havingAnOffer && tradeInData.offeredPrice) && <p styleName={"styles.subHeading"}>Enter your car details to get estimated<br />trade-in valuation.</p> }
            </div>
            {renderCard()}
        </div>
    );
};

CdpCarToTradeIn.propTypes = {
    tradeInData: PropTypes.object,
    setRedirectionDataConnect: PropTypes.func,
    gaId: PropTypes.string
};

export default CdpCarToTradeIn;
